export const getInitialState = () => {
    return {
        speakerDetails: {
          isSpeakerSpeaking : false
      }
    };
};